<template>
  <standard-dialog
    v-model="model"
    :title="isEdit ? $t('edit_stocktaking') : $t('new_stocktaking')"
    icon="mdi-clipboard-check-outline"
    max-width="500"
    :save-text="$t('save')"
    :loading="loading"
    :disabled="!valid"
    @save="save"
    @close="resetForm"
  >
    <v-form ref="form" v-model="valid">
      <choose-warehouse-field v-model="form.warehouse_id" />
      <text-field
        v-model="form.name"
        :label="$t('warehouse.document_number')"
        required
        :rules="[rules.required]"
      />
      <date-picker v-model="form.date" :label="$t('date')" single-date required />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasValidation from "@/mixins/hasValidation";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import warehouseService from "@/services/warehouse";
import ChooseWarehouseField from "@/components/warehouse/field/ChooseWarehouseField.vue";

export default {
  name: "StocktakingDialog",
  components: {
    StandardDialog,
    ChooseWarehouseField,
  },
  mixins: [hasModel, hasSnackbar, hasValidation],
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        warehouse_id: null,
        name: "",
        date: new Date().toISOString().substr(0, 10),
      },
    };
  },
  computed: {
    warehouses() {
      return this.$store.state.warehouse.items || [];
    },
    isEdit() {
      return this.editedItem && this.editedItem.id;
    },
  },
  watch: {
    model(val) {
      if (val && this.editedItem) {
        this.form = {
          warehouse_id: this.editedItem.warehouse_id,
          name: this.editedItem.name,
          date: this.editedItem.date,
        };
      } else if (!val) {
        this.resetForm();
      }
    },
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const payload = {
          name: this.form.name,
          date: this.form.date,
          warehouse_id: this.form.warehouse_id,
        };

        if (this.isEdit) {
          const res = await warehouseService.updateWarehouseStocktaking(
            this.form.warehouse_id,
            this.editedItem.id,
            payload
          );
          this.showSuccessSnackbar(this.$t("stocktaking_updated_successfully"));
          this.$emit("updated", res.data);
        } else {
          const res = await warehouseService.createWarehouseStocktaking(
            this.form.warehouse_id,
            payload
          );
          this.showSuccessSnackbar(this.$t("stocktaking_created_successfully"));
          this.$emit("created", res.data);
        }
        this.model = false;
      } catch (err) {
        this.showErrorSnackbar(
          err.response?.data?.message ||
            (this.isEdit
              ? this.$t("error_updating_stocktaking")
              : this.$t("error_creating_stocktaking"))
        );
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        warehouse_id: null,
        name: "",
        date: new Date().toISOString().substr(0, 10),
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
